var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home_title_item"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"sub"},[_vm._v(_vm._s(_vm.sub))])])
}
var staticRenderFns = []

export { render, staticRenderFns }